import { memo, useEffect, useCallback, useRef } from 'react';
// @ts-expect-error No types
import { PDFPageView, EventBus } from 'documents-lib/lib/pdf-js';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const PDFPageImage = ({
  pageObject,
  viewport,
  pageIndex
}) => {
  const pdfPageViewRef = useRef(null);
  const renderPageImage = useCallback(() => {
    const {
      scale
    } = viewport;
    // Create a PDFPageView
    if (!pdfPageViewRef.current) {
      pdfPageViewRef.current = new PDFPageView({
        container: document.querySelector('#pdf-content-container'),
        scale,
        defaultViewport: viewport,
        eventBus: new EventBus()
      });
    }

    // Render the PDF page
    pdfPageViewRef.current.setPdfPage(pageObject);
    pdfPageViewRef.current.draw(viewport, 'display');
  }, [pageObject, viewport]);
  useEffect(() => {
    renderPageImage();
  }, [renderPageImage, pageObject, viewport, pageIndex]);
  return /*#__PURE__*/_jsx(View, {
    id: 'pdf-content-container',
    margin: "auto",
    as: "div"
  });
};
export default /*#__PURE__*/memo(PDFPageImage);